import React from 'react';
import classNames from 'classnames';

import { i18n as I18n } from 'utils/i18n';

interface Props {
  className?: any;
  label?: string;
  added?: boolean;
  enabled?: boolean;
  desktop?: boolean;
  onClick?: () => void;
}

const AddToBookingButton: React.FC<Props> = ({
  className,
  label: labelProp,
  added,
  enabled,
  desktop,
  ...props
}) => {
  const classes = classNames(
    {
      button: true,
      'button--medium': true,
      'button--primary': !added,
      'button--tertiary': !enabled,
      'button--quaternary': added,
    },
    className
  );

  const getLabel = () => {
    if (labelProp !== undefined) return labelProp;
    if (added) return I18n.t('shared.booking_added');
    return I18n.t(desktop ? 'shared.add_to_booking' : 'shared.book');
  };

  const label = getLabel();

  return (
    <button
      data-testid="addToBookingButton"
      data-cy="addToBookingButton"
      {...props}
      className={classes}
      disabled={added}
    >
      {label}
    </button>
  );
};

AddToBookingButton.defaultProps = {
  added: false,
  enabled: true,
  desktop: false,
};

export default AddToBookingButton;
